import client from './client'

/** Redirect browser to Google consent screen */
export function initiateGoogleLogin(): void {
  window.location.href = '/auth/google'
}

/**
 * Explicitly requests a token refresh. Used when the caller knows the access token
 * is expired. Under normal conditions the axios interceptor handles this automatically;
 * this export is provided for manual invocations if needed.
 *
 * Throws if the refresh token is absent or expired.
 */
export async function refreshToken(): Promise<void> {
  await client.post('/auth/refresh')
}

/** Log the user out — backend clears both JWT cookies */
export async function logout(): Promise<void> {
  try {
    await client.post('/auth/logout')
  } catch {
    // Even if logout fails (e.g., access token already expired), we still clear
    // local state and navigate to the login page.
  }
  window.location.href = '/login'
}
